import { getMessages } from '../../../../../../../store/constants';

export const MESSAGE_DUE_DATE = getMessages().getText('activity_item_card__due_date');
